//Require SASS
require('../scss/fas.asso.scss')
require('../scss/editor.scss')

//Require CSS
// require('../style.css')

 

//Require scripts
import './vendor/jquery.scrollTo.min'
require('./script')


//////////////////
// WEBPACK FOOTER
// ./js/app.js
// module id = 0
// module chunks = 0